import { useEffect, useState } from 'react'
import { Table } from 'entities/Table'
import { Button } from 'entities/Button'
import Accordion from 'entities/Accordion'
import { useNotificationsStore } from 'shared/store/notificationsSlice'
import { GridRowSelectionModel } from '@mui/x-data-grid-premium'
import { NotificationsModal } from './notificationsModal'

export const NotificationsAccordion = () => {
  const { userList, loadUserList, isUserListLoading } = useNotificationsStore()
  const [selectedUsers, setSelectedUsers] = useState<GridRowSelectionModel>([])
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] = useState<boolean>(false)

  useEffect(() => {
    // TODO: load also in initial loading
    loadUserList()
  }, [])

  return (
    <Accordion title='Users' defaultExpanded>
      <Button
        isDisabled={!selectedUsers?.length}
        width='100%'
        handleClick={() => {
          setIsNotificationsModalOpen(prevValue => !prevValue)
        }}
      >
        {selectedUsers?.length ? 'Create Notification' : 'Select users'}
      </Button>
      <Table
        loading={isUserListLoading}
        sx={{ marginTop: '20px', width: '100%' }}
        rows={userList}
        columns={[
          {
            field: 'phoneNumber',
            headerName: 'Phone Number',
            minWidth: 170
          },
          {
            field: 'customerName',
            headerName: 'Customer Name',
            width: 175,
            flex: 1
          }
        ]}
        getRowId={(item: any) => item.deviceToken}
        checkboxSelection
        onRowSelectionModelChange={setSelectedUsers}
      />
      <NotificationsModal
        isOpen={isNotificationsModalOpen}
        onClose={() => setIsNotificationsModalOpen(false)}
        headerTitle='Create notification'
        selectedUsers={selectedUsers?.map(sUser => {
          const user = userList?.find(u => u.deviceToken === sUser)
          return {
            phoneNumber: user?.phoneNumber || null,
            token: user?.deviceToken || null
          }
        })}
      />
    </Accordion>
  )
}
